var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User_Management",
    "data-name": "User Management",
    transform: "translate(-502 -1976)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    width: 64,
    height: 64,
    rx: 2,
    transform: "translate(502 1976)",
    fill: "rgba(251,139,35,0.1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50723",
    "data-name": "Group 50723",
    transform: "translate(0 -160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "partner",
    transform: "translate(518 2152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17446",
    "data-name": "Group 17446",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17443",
    "data-name": "Group 17443",
    transform: "translate(23.281 15.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17442",
    "data-name": "Group 17442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17441",
    "data-name": "Group 17441"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10489",
    "data-name": "Path 10489",
    d: "M373.27,244.921a.631.631,0,1,1,.614-.488.638.638,0,0,1-.614.488Z",
    transform: "translate(-372.64 -243.66)",
    fill: "#fb8b23"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10490",
    "data-name": "Path 10490",
    d: "M23.86,23l-1.423-1.425a8.52,8.52,0,0,0,1.569-2.691.624.624,0,1,0-1.175-.422,7.273,7.273,0,0,1-1.6,2.581A3.638,3.638,0,0,0,18.74,18.7a3.959,3.959,0,1,0-5.524,0,3.638,3.638,0,0,0-2.494,2.347,7.285,7.285,0,1,1,12.005-7.782.624.624,0,1,0,1.157-.469,8.528,8.528,0,0,0-1.454-2.38l1.42-1.422a2.772,2.772,0,1,0-.881-.886L21.547,9.532a8.622,8.622,0,0,0-.748-.577,8.462,8.462,0,0,0-4.2-1.472V5.469a2.766,2.766,0,1,0-1.248,0V7.483a8.486,8.486,0,0,0-4.941,2.052L8.986,8.107a2.76,2.76,0,1,0-.881.886l1.424,1.426a8.511,8.511,0,0,0-2.056,4.949H5.46a2.77,2.77,0,1,0,0,1.25H7.472a8.465,8.465,0,0,0,2.045,4.961L8.1,23a2.772,2.772,0,1,0,.885.882L10.4,22.461q.182.157.374.306l0,0a8.43,8.43,0,0,0,4.577,1.749v2.013a2.766,2.766,0,1,0,1.248,0V24.517a8.43,8.43,0,0,0,4.577-1.749h0q.192-.148.374-.306l1.421,1.423A2.765,2.765,0,1,0,23.86,23Zm-7.882-9.856a2.715,2.715,0,1,1-2.711,2.715A2.716,2.716,0,0,1,15.978,13.145Zm0,10.145a7.2,7.2,0,0,1-4.185-1.324,2.377,2.377,0,0,1,2.361-2.141H17.8a2.377,2.377,0,0,1,2.361,2.141,7.2,7.2,0,0,1-4.185,1.324Z",
    transform: "translate(0 0)",
    fill: "#fb8b23"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17445",
    "data-name": "Group 17445",
    transform: "translate(26.404 13.202)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17444",
    "data-name": "Group 17444"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10491",
    "data-name": "Path 10491",
    d: "M426.152,217.273a2.8,2.8,0,1,1,2.8-2.8A2.8,2.8,0,0,1,426.152,217.273Zm0-4.333a1.535,1.535,0,1,0,1.535,1.535A1.537,1.537,0,0,0,426.152,212.939Z",
    transform: "translate(-423.354 -211.677)",
    fill: "#fb8b23"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Path-2",
    "data-name": "Path",
    width: 40,
    height: 40,
    rx: 2,
    transform: "translate(514 2148)",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature2);
export default __webpack_public_path__ + "static/media/feature2.1e71f9dae2ed609b7462e244168b1f02.svg";
export { ForwardRef as ReactComponent };